import styled, { css } from 'styled-components'

export const Row = styled.div`
  display: flex;
  align-items: center;
  position: relative;
`

export const Title = styled.p`
  margin-right: 1.5rem;
  font-size: 1.25rem;
  text-transform: uppercase;
  display: inline-block;
  vertical-align: middle;
  color: white;
  letter-spacing: 0.1em;
  white-space: pre;
`

export const CreateButton = styled.button`
  display: flex;
  flex-direction: row;
  align-items: center;
  background: transparent;
  border: none;
  cursor: pointer;
  outline: none;
  margin-left: auto;

  &:hover .icon {
    color: black;
    background-color: white;
  }

  &:hover .label {
    color: white;
  }
`

export const Icon = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid white;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  font-size: 2.5rem;
  color: white;
  margin-right: 8px;
  transition: all 0.3s ease;

  &.icon {
    transition: color 0.3s ease, background-color 0.3s ease;
  }
`

export const Label = styled.div`
  color: white;
  transition: color 0.3s ease;

  &.label {
    transition: color 0.3s ease;
  }
`

export const PlaylistGrid = styled.div`
  ${({ $responsiveBreakpointsV2 }) =>
    $responsiveBreakpointsV2 &&
    css`
      display: grid;
      grid-template-columns: repeat(
        auto-fill,
        minmax(min(100%, max(400px, calc(100% / 7))), 1fr)
      );
    `}
`
